// Only allow the fixed timer destination, never a caller-provided URL.
export const isTimerLoginRedirect = (value: unknown) => value === 'timer'

export const afterLoginDestination = (redirect: unknown) => ({
    name: isTimerLoginRedirect(redirect) ? 'timer' : 'member'
})
